import { jsx as i } from "react/jsx-runtime";
import { ProductCardHorizontal as b } from "./ProductCardHorizontal/index.js";
import { ProductCardVertical as g } from "./ProductCardVertical/index.js";
/* empty css                                                      */const E = ({
  product: l,
  variant: r,
  hasPlusFriendBadge: C = !1,
  hasPromotionalPrice: f,
  clubPrice: s,
  defaultScListPrice: x,
  hasClub: m,
  isClubClient: H,
  openModal: V,
  promotion: d,
  outOfStock: e,
  addToCartAction: j,
  quantitySelectorAction: p,
  productInCart: t
}) => {
  const z = !!(m && H);
  return /* @__PURE__ */ i("div", { style: { height: "100%" }, children: r === "vertical" ? /* @__PURE__ */ i(
    g,
    {
      isClubClient: z,
      hasClub: m,
      defaultScListPrice: x,
      hasPromotionalPrice: f,
      product: l,
      variant: r,
      outOfStock: e,
      promotion: d,
      clubPrice: s,
      openModal: V,
      hasPlusFriendBadge: C,
      addToCartAction: j,
      quantitySelectorAction: p,
      productInCart: t
    }
  ) : /* @__PURE__ */ i(
    b,
    {
      openModal: V,
      isClubClient: z,
      hasClub: m,
      defaultScListPrice: x,
      hasPromotionalPrice: f,
      product: l,
      variant: r,
      hasPlusFriendBadge: C,
      outOfStock: e,
      promotion: d,
      clubPrice: s,
      addToCartAction: j,
      quantitySelectorAction: p,
      productInCart: t
    }
  ) });
};
export {
  E as ProductCard
};
